document.addEventListener("DOMContentLoaded", () => {
  const pairButtons = document.querySelectorAll(".pair-buttons button");
  const quantityInput = document.querySelector("input[name='quantity']");
  const priceElement = document.querySelector("product-rerender sale-price");

  // Get base price from data attribute (already in øre)
  const basePrice = priceElement ? parseInt(priceElement.dataset.price, 10) : 0;
  
  const formatPrice = (value) => {
    return new Intl.NumberFormat('da-DK', {
      style: 'currency',
      currency: 'DKK'
    }).format(value / 100);
  };
  
  pairButtons.forEach((button) => {
    button.addEventListener("click", () => {
      // Remove data-selected from all buttons
      pairButtons.forEach((btn) => btn.setAttribute("data-selected", "false"));

      // Set data-selected="true" for the clicked button
      button.setAttribute("data-selected", "true");

      const isPair = button.id === "two";
      quantityInput.value = isPair ? "2" : "1";
      let newPrice;

      if (priceElement && basePrice) {
        newPrice = basePrice * (isPair ? 2 : 1);
        priceElement.textContent = formatPrice(newPrice);
      }
    });
  });
});
$(document).ready(function() {
  $('.footer__block-list .footer__block--text .h6, .footer__block-list .footer__block--links .h6').on('click', function () {
    const $parent = $(this).parent();
    const $target = $parent.find('.text-subdued, .unstyled-list');
    $target.toggleClass('open');
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector(".ProductForm__Item[aria-controls='123abc']");
  const popover = document.getElementById("123abc");
  let popoverOverlay = $(".Product__OffScreen");

  let currentWindowWidth = $(window).outerWidth();
  let resizeTimeout;

  // Handle resize
  $(window).on("resize", function () {
    currentWindowWidth = $(window).outerWidth();

    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      closePopover();
    }, 200);
  });

  // Toggle popover on button click
  button.addEventListener("click", function (e) {
    const isExpanded = button.getAttribute("aria-expanded") === "true";
    if (isExpanded) {
      closePopover();
    } else {
      openPopover(currentWindowWidth);
    }
  });

  // Open popover with positioning
  function openPopover(windowWidth) {
    $('body').addClass('locked');

    const rect = button.getBoundingClientRect();
    const popoverWidth = $('#123abc').outerWidth();
    const popoverHeight = $('#123abc').outerHeight();

    if (windowWidth > 1000) {
      popover.style.top = `${rect.top - (popoverHeight / 2)}px`;
      popover.style.left = `${rect.left - (popoverWidth + 20)}px`;
      popover.style.bottom = 'auto';
    } else {
      popover.style.bottom = '0px';
      popoverOverlay.addClass('open');
      popover.style.top = 'auto';
      popover.style.left = '0px';      
    }

    button.setAttribute("aria-expanded", "true");
    popover.setAttribute("aria-hidden", "false");
    popover.style.visibility = "visible";
    popover.style.opacity = "1";
  }

  // Close popover
  function closePopover() {
    button.setAttribute("aria-expanded", "false");
    popover.setAttribute("aria-hidden", "true");
    popover.style.visibility = "hidden";
    popover.style.opacity = "0";
    $('body').removeClass('locked');
    popoverOverlay.removeClass('open');
  }

  // Close on outside click
  document.addEventListener("click", function (e) {
    if (!button.contains(e.target) && !popover.contains(e.target)) {
      closePopover();
    }
  });

  // Close button inside popover
  const closeBtn = popover.querySelector("[data-action='close-popover']");
  if (closeBtn) {
    closeBtn.addEventListener("click", closePopover);
  }
});